export const URLS = {
  ANDROID_DOWNLOAD: 'https://play.google.com/store/apps/details?id=com.goeverbright.MyEverBright',
  IOS_DOWNLOAD: 'https://apps.apple.com/us/app/myeverbright/id1641960636',
  EVERBRIGHT_ONLINE_ACCOUNT: 'https://everbright.youronlineaccount.com/pub/ssoamup.aspx',
  LAUNCH_SSO: 'https://everbright-uat.youronlineaccount.com/pub/ssoamup.aspx',
  EVERBRIGHT_OMNIDIAN_LOGIN: 'https://everbright.omnidian.com/#/login',
} as const;

export default URLS;
